/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S4_Li1_TermInputs */

const tr_iade_iptal_s4_li1_term = /** @type {(inputs: Iade_Iptal_S4_Li1_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kutu işaretlenirse:`)
};

const en_iade_iptal_s4_li1_term = /** @type {(inputs: Iade_Iptal_S4_Li1_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If the box is ticked:`)
};

const de_iade_iptal_s4_li1_term = /** @type {(inputs: Iade_Iptal_S4_Li1_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird das Feld angekreuzt:`)
};

const ru_iade_iptal_s4_li1_term = /** @type {(inputs: Iade_Iptal_S4_Li1_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Если поле отмечено:`)
};

/**
* | output |
* | --- |
* | "If the box is ticked:" |
*
* @param {Iade_Iptal_S4_Li1_TermInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s4_li1_term = /** @type {((inputs?: Iade_Iptal_S4_Li1_TermInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S4_Li1_TermInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s4_li1_term(inputs)
	if (locale === "de") return de_iade_iptal_s4_li1_term(inputs)
	if (locale === "ru") return ru_iade_iptal_s4_li1_term(inputs)
	return tr_iade_iptal_s4_li1_term(inputs)
});